var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoArtist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-artist",
    transform: "translate(-1681 -426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ico-artist-2",
    "data-name": "ico-artist",
    d: "M6.939,14.033c-.232.624-.429,1.2-.6,1.783a7.254,7.254,0,0,1,3.418-1.3,8,8,0,0,0,5.876-4.059L14.172,9l1.413-1.415,1-1a8.362,8.362,0,0,0,1.427-2.368C12.42,5.082,8.995,8.506,6.939,14.033ZM17,9l1,1a9.937,9.937,0,0,1-8,6.5Q6,17,5,22H3C4,16,6,2,21,2q-1.5,4.5-3,6Z",
    transform: "translate(1681 426.003)",
    fill: "#007cb4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 24,
    height: 24,
    transform: "translate(1681 426)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArtist);
export default __webpack_public_path__ + "static/media/ico-artist.e1667021ee887dbcabc77f732d939870.svg";
export { ForwardRef as ReactComponent };